export default __webpack_public_path__ + "static/media/instantly-send-image.21247eff.png";